<template>
  <div class="fromStyle">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item ref="name" label="外包平台名称" prop="name">
        <a-input style="width:150px" v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item ref="name" label="费率" prop="rate">
        <a-input-number v-model="form.rate" />
        <span>&nbsp;%</span>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button @click="resetForm">
          重置
        </a-button>
        <a-button style="margin-left: 20px;" type="primary" @click="onSubmit">
          提交
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      form: {
        name: "",
        rate: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写外包平台名称",
            trigger: "blur"
          }
        ],
        rate: [
          {
            required: true,
            message: "请填写费率",
            trigger: "blur"
          }
        ]
      },
      details: {}
    };
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetails();
    }
  },
  mounted() {
    if (this.editDetail != "") {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.editDetail;
      this.form = {
        name: this.details.name,
        rate: this.details.rate
      };
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.finance +
            "Finance_platform/edit";
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            name: this.form.name,
            rate: this.form.rate,
            id: this.details.id
          };
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.$emit("hideInEdit", false);
              this.resetForm();
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 100px 4% 0;
  padding-bottom: 30px;
}
</style>
